import { customFormatMoney, toFixed } from 'services/accountingServices'
import Vue from 'vue'

const moneyFormat = function(money = 0, symbol) {
	symbol = symbol === undefined ? 'R$' : symbol
	return customFormatMoney(toFixed(money), { symbol, decimal: ',', thousand: '.' })
}

Vue.filter('moneyFormat', moneyFormat)
